<template>    
    <BaseModal
        :id="'static-update-template'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index, 'static-update-template')">
                <FormDynamic
                    :form_format="local_form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                    name="TemplateUpdateModal"
                />

                <div class="row mb-0 mt-2 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="single_object.rooms || []"
                                :search="search"
                                name="template_update_modal"
                                ref="template_update_modal"
                            />
                        </v-card>
                    </div>
                </div>
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources  from './form_resources'
import FormDynamic    from '@/components/FormDynamic.vue'
import Breadcrumb     from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal      from '@/components/BaseModal'
import CentralButtons from '@/components/CentralButtons'
import DinamicTable   from  '@/components/DinamicTable'

export default {

    name:   'UpdateModalTemplate',

    props: [
        'title',
        'rest_api',
        'notyf',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
        DinamicTable,
    },

    data(){
        return{
            form_format: FormResources.form_format_lite,
            search:             '',
            table_selection:    [],
            local_form_format: [],
            table_headers: [
                { 
                  text:     '# Room',
                  value:    'door_number', 
                },
                { 
                  text:     'Description',
                  value:    'description'
                },
                { 
                  text:     'Walking #',
                  value:    'walking_number'
                },
            ],
        }
    },
    
    methods:{
        async setupForm(single_object) 
        {
            this.loader(true)

            const response = await this.get(`${this.rest_api}/get/inspection_rooms/${single_object.id}`)

            if(response.status)
            {
                console.log(response.data.inspection_rooms);
                this.single_object.rooms = response.data.inspection_rooms
                this.single_object.room_ids = this.single_object.rooms.map( item => {
                    return item.id
                })
            }
            else
            {
                this.error_handling(response)
            }

            this.loader()
        },
    },

    mounted()
    {
        this.local_form_format = JSON.parse(JSON.stringify(this.form_format));
        this.local_form_format[0].disabled = true

    }
    
}
</script>